export default {
  computed: {
    itemList() {
      const baseList = this.$store.state[this.optionConfig.entityName].list;
      if (!this.optionConfig.filterIf) {
        return baseList;
      }
      return baseList.filter(item => item[this.optionConfig.filterIf]);
    },
  },
  async created() {
    await this.$store.dispatch(`${this.optionConfig.entityName}/list`, {
      reload: false,
    });
  },
  props: {
    optionConfig: {
      required: true,
      type: Object,
    },
  },
  watch: {
    value: function (newVal) {
      if (
        !this.optionConfig ||
        !this.optionConfig.andSet ||
        !this.optionConfig.entityAttributeName
      ) {
        return;
      }

      const {
        attributeMap,
        optionConfig: { entityAttributeName, andSet },
      } = this;

      const entity = this.itemList.find(
        item => item[entityAttributeName] === newVal
      );

      if (!entity) {
        return;
      }

      andSet.forEach(
        ({
          entityAttributeName: setEntityAttributeName,
          attributeName: setAttributeName,
        }) => {
          if (!setEntityAttributeName || !setAttributeName) {
            return;
          }

          this.$set(
            attributeMap,
            setAttributeName,
            entity[setEntityAttributeName]
          );
        }
      );

      this.$emit("change", attributeMap);
    },
  },
};
